var render = function render(_c,_vm){return _c('div',[(_vm.props.row.Time > 0)?_c('strong',{staticClass:"red"},[_vm._v(_vm._s(_vm.props.row.Time))]):_c('strong')])
}
var staticRenderFns = []

export { render, staticRenderFns }